import { Icon } from 'antd';
import React, { Fragment } from 'react';

interface TagProps {
  /** hex string 不带 alpha 通道 */
  color: string;
  /** dom.tagName default is span */
  tagName?: string;
  style?: React.CSSProperties;
  children?: JSX.Element | React.Component<any, any> | string;
  icon?: string;
  className?: string;
  onClick?: () => any;
}

export default function Tag(props: TagProps) {
  const fn = () => 0;
  const {
    tagName = 'span',
    color,
    style = {},
    icon,
    className,
    onClick = fn,
  } = props;
  return React.createElement(tagName, {
    style: Object.assign({}, style, {
      color,
      background: `${color}1a`,
      border: `1px solid ${color}e3`,
      borderRadius: '0.2em',
      padding: '0 0.5em',
    }),
    className,
    onClick,
    children: (
      <Fragment>
        {props.children}
        {icon && <Icon type={icon} />}
      </Fragment>
    ),
  });
}
